import type { ReactNode } from 'react'
import { Route, Routes, type RoutesProps } from 'react-router'

const RoutesWithNotFound = ({ children, ...props }: { children: ReactNode } & RoutesProps) => (
  <Routes {...props}>
    {children}
    <Route path="*" element={<h1>404 Not Found</h1>} />
  </Routes>
)

export default RoutesWithNotFound
